// extracted by mini-css-extract-plugin
module.exports = {"page":"PackRegistration_page__1h-ds"};